<div
  class="file-upload border-grey-4 text-primary rounded-lg border border-dashed"
  [class.success]="uploadSucceeded()"
  [class.error]="uploadFailed()"
  (drop)="onFileDrop($event)"
  (dragover)="onDragOver($event)"
>
  <input
    class="hidden"
    #fileInput
    [accept]="acceptTypes()"
    [disabled]="!canChange()"
    (change)="onFileChange($event)"
    type="file"
  />
  <div class="file-upload-dropper py-md" (click)="fileInput.click()">
    @if (hasFile()) {
      @if (preview()) {
        <img class="preview" [src]="preview()" alt="" />
      }
      <div class="flex items-center gap-4">
        <ng-icon name="lucideUpload" />
        <p>
          @if (isFileRemote()) {
            <a
              [href]="fileSource()"
              (click)="$event.stopPropagation()"
              hlmBtn
              variant="link"
              size="compact"
              target="_blank"
            >
              {{ fileName() }}
            </a>
          } @else {
            <span class="paragraph-medium-semibold">
              {{ fileName() }}
            </span>
          }
          @if (fileSize()) {
            <span class="paragraph-medium-medium">({{ fileSize() }} kiB)</span>
          }
        </p>
        @if (canChange()) {
          <button
            (click)="remove($event)"
            hlmBtn
            variant="ghost"
            size="icon"
            aria-label="Supprimer le fichier"
            type="button"
          >
            <ng-icon class="delete-icon" name="lucideTrash" />
          </button>
        }
      </div>
    } @else {
      <div class="gap-md flex flex-col items-center text-center">
        <ng-icon hlm name="lucideUpload" size="xl" />
        <div class="gap-xs flex flex-col">
          <label class="paragraph-large-semibold">{{ dragDropText() }}</label>
          <span>ou</span>
          <button hlmBtn type="button">
            {{ buttonText() }}
          </button>
        </div>
      </div>
    }
  </div>
  @if (uploadProgress()) {
    <hlm-progress [value]="uploadProgress()">
      <hlm-progress-indicator />
    </hlm-progress>
  }
</div>
<span class="paragraph-medium-medium">
  {{ hintText() }}
</span>
